import { Unit } from '@prismamedia/one-brandkey';
import { Auth } from '@prismamedia/one-components';
import { RoleUnit } from '@prismamedia/one-user';

export const auth = new Auth(config.API_ONE_AUTH);

const ONE_AUTH_BASE_URL = config.API_ONE_AUTH.replace(/\/$/, '');

export const loginWithAzureIdToken = async (azureIdToken: string) => {
  const response = await fetch(`${ONE_AUTH_BASE_URL}/azure-login`, {
    headers: new Headers({
      Authorization: `Bearer ${azureIdToken}`,
    }),
    mode: 'cors',
    cache: 'default',
  });
  const payload = await response.json();
  if (!response.ok || !payload.id_token) {
    throw new Error('Erreur de connexion');
  }

  ((auth as unknown) as { _setJwt: (token: string) => void })._setJwt(
    payload.id_token,
  );
  return payload.id_token as string;
};

export const isUserAdmin = () =>
  auth.user?.isSuperAdmin() ||
  auth.user?.isAdmin() ||
  auth.user?.isAdmin(Unit.PECO as RoleUnit) ||
  auth.user?.isAdmin(Unit.PFEM as RoleUnit) ||
  auth.user?.isAdmin(Unit.PTVS as RoleUnit) ||
  auth.user?.isAdmin(Unit.GEO as RoleUnit);
